"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberModel = void 0;
const mobx_1 = require("mobx");
class NumberModel {
    constructor(initial = 0) {
        this.setValue = (v) => {
            this._value = v;
        };
        this.reset = () => {
            this._value = this._initial;
        };
        this.increment = (d = 1) => this.value += d;
        this.decrement = (d = 1) => this.value -= d;
        this._initial = initial;
        this._value = this._initial;
        (0, mobx_1.makeObservable)(this, {
            _value: mobx_1.observable,
            setValue: mobx_1.action,
            reset: mobx_1.action,
            increment: mobx_1.action,
            decrement: mobx_1.action,
        });
    }
    get value() { return this._value; }
    set value(v) { this.setValue(v); }
    get isDefault() { return this._value === this._initial; }
}
exports.NumberModel = NumberModel;
exports.default = NumberModel;
//# sourceMappingURL=NumberModel.js.map